import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Service, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { KDateEndOf, KDateFormat, KDateFormatTz, KDateParse, KDateParseTz, KDateStartOf } from '@kiwid-app/kiwid-date-typescript';
import { IDateTzString } from '@kiwid-app/kiwid-date-typescript/dist/types';
import { Util } from 'app/core/helpers/util';
import { IDataPagination } from 'app/core/models/api/data';
import { IGetTimezone, ITimezone } from 'app/core/models/timezone/timezone';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { DATE_TIME_API } from '../../const/date.const';
import { IError } from '../../models/error/error';
import { AuthenticationService } from '../authentication/authentication.service';

export const timezone = () => inject(TimezoneService);
export const urlGetAllTimezone = () => ['timezone'];

@Service()
export class TimezoneService {
    // inject
    private readonly router = inject(Router);
    private readonly httpClient = inject(HttpClient);
    private readonly authenticationService = inject(AuthenticationService);

    public readonly timezone = computed(() => this.authenticationService.locationDefault().timezone);

    getNowByTimezone(timezone: string): Date {
        return KDateParse({
            value: this.formatToTimezoneByTimezone(timezone, new Date(), DATE_TIME_API),
            format: DATE_TIME_API,
        });
    }

    formatToTimezoneByTimezone(timezone: string, date: IDateTzString | Date, formatDate: string): string {
        return KDateFormatTz(date, timezone, formatDate);
    }

    dateToISO(locationId: string, date: string, format: string, timezone: string): string {
        return KDateParseTz(
            {
                value: KDateFormat({ value: date, format }, DATE_TIME_API),
                format: DATE_TIME_API,
            },
            timezone,
        ).toISOString();
    }

    dateToISOByTimezone(timezone: string, date: string, format: string): string {
        return KDateParseTz(
            {
                value: KDateFormat({ value: date, format }, DATE_TIME_API),
                format: DATE_TIME_API,
            },
            timezone,
        ).toISOString();
    }

    getAllTimezones({ search, ...parameters }: IGetTimezone): Observable<IDataPagination<ITimezone[]>> {
        const url = this.router.createUrlTree(urlGetAllTimezone(), {
            queryParams: {
                ...parameters,
                search: search
                    .replace('(', '')
                    .replace(')', '')
                    .replace("'", '')
                    .replace('ã', 'a')
                    .replace('ç', 'c')
                    .replace('á', 'a')
                    .replace('é', 'e'),
            },
        });

        const parsedUrl = `${environment.apiUrl}/${environment.apiVersion}${url}`;

        return this.httpClient.get(parsedUrl, { responseType: 'json' }).pipe(
            map((res: IDataPagination<ITimezone[]>) => {
                return res;
            }),
            catchError((error: HttpErrorResponse) => {
                if (error.error instanceof ErrorEvent) {
                    return throwError(() => `Error: ${error.error.message}`);
                }
                const errorApi: IError = error.error.error;
                return throwError(() => errorApi);
            }),
        );
    }
}
